export interface OffSiteRates {
  customerTransportPerKm: number;
  fuelPerKm: number;
  sntPerNight: number;
  dinnerPerNight: number;
  breakfastPerNight: number;
}

export const DEFAULT_OFF_SITE_RATES: OffSiteRates = {
  customerTransportPerKm: 4,
  fuelPerKm: 4.5,
  sntPerNight: 184,
  dinnerPerNight: 150,
  breakfastPerNight: 120
};

const RATE_KEYS = new Map<string, keyof OffSiteRates>([
  ["customer_transport_per_km", "customerTransportPerKm"],
  ["fuel_per_km", "fuelPerKm"],
  ["snt_per_night", "sntPerNight"],
  ["dinner_per_night", "dinnerPerNight"],
  ["breakfast_per_night", "breakfastPerNight"]
]);

export function mapOffSiteRates(rates: any[]): OffSiteRates {
  return rates.reduce(
    (mapped: OffSiteRates, rate: any) => {
      const key = RATE_KEYS.get(rate.code);
      if (key) mapped[key] = Number(rate.amount || 0);
      return mapped;
    },
    { ...DEFAULT_OFF_SITE_RATES }
  );
}
